import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ProfileSidebar from '~/profile-sidebar';
import { contentPage } from '~/routes';

import { useSplitEnabledWithConfig } from '@bufferapp/features';
import { useAccount } from '~/accountContext';

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
`;

const ProfileSidebarStyle = styled.div`
  flex-basis: 16rem;
  width: 16rem;
  min-width: 16rem;
  position: sticky;
  bottom: 0;
  top: 0;
  max-height: 100vh;
`;

const ContentStyle = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const PageWithSidebarWrapper = ({ children, profileId, tabId, className }) => {
  const isContentSelected = window?.location?.pathname.startsWith(
    contentPage.route
  );

  /*
   * Experiment 75 : We are going to test the performance of to put Create menu option on top,
   *  in the main menu versus to keep in the sidebar, only for new users at 50/50
   *
   * Segment A (Create option in the sidebar with magic wand)
   * Segment B (Create option in the main menu)
   */
  const { account } = useAccount();

  const currentOrganizationCreationDate =
    account?.currentOrganization?.createdAt;

  const epochsMs = currentOrganizationCreationDate
    ? new Date(currentOrganizationCreationDate).getTime()
    : 0;

  const { isEnabled: isEID75SegmentBEnabled } = useSplitEnabledWithConfig(
    'EID75-create-mainmenu-vs-sidebar',
    { signUpDate: epochsMs },
    'b'
  );

  const shouldDisplaySidebar = !isEID75SegmentBEnabled || !isContentSelected;

  return (
    <Wrapper className={className}>
      {shouldDisplaySidebar && (
        <ProfileSidebarStyle>
          <ProfileSidebar profileId={profileId} tabId={tabId} />
        </ProfileSidebarStyle>
      )}
      <ContentStyle>{children}</ContentStyle>
    </Wrapper>
  );
};

PageWithSidebarWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  profileId: PropTypes.string,
  tabId: PropTypes.string,
  className: PropTypes.string,
};

PageWithSidebarWrapper.defaultProps = {
  profileId: null,
  tabId: null,
  className: '',
};

export default PageWithSidebarWrapper;
